import { computed as e, createBlock as t, createCommentVNode as n, createElementBlock as r, createVNode as i, defineComponent as a, openBlock as o, resolveDynamicComponent as s, toDisplayString as c, unref as l, withCtx as u } from "vue";
import { ScalarIconBook as d } from "@scalar/icons";
import { getResolvedRef as f } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { sanitizeUrl as p } from "@scalar/helpers/url/is-safe-url";
//#region src/shared/ExternalDocs.vue?vue&type=script&setup=true&lang.ts
var m = {
	key: 0,
	class: "group narrow:border-r-0 narrow:first:ml-0 flex items-center border-r first:ml-auto last:border-r-0"
}, h = {
	key: 0,
	class: "ml-1 empty:hidden"
}, g = {
	key: 1,
	class: "ml-1 empty:hidden"
}, _ = /*@__PURE__*/ a({
	__name: "ExternalDocs",
	props: { value: {} },
	setup(a) {
		let _ = e(() => {
			let e = f(a.value);
			return e && typeof e.url == "string" && e.url ? e : void 0;
		}), v = e(() => p(_.value?.url));
		return (e, a) => _.value ? (o(), r("div", m, [(o(), t(s(v.value ? "a" : "span"), {
			"aria-label": _.value.description || _.value.url,
			class: "text-c-1 hover:bg-b-2 narrow:border mr-2 flex min-h-7 min-w-7 items-center rounded-lg px-2 py-1 no-underline group-last:mr-0",
			href: v.value,
			rel: v.value ? "noopener noreferrer" : void 0,
			target: v.value ? "_blank" : void 0
		}, {
			default: u(() => [i(l(d), {
				class: "size-3 text-current",
				weight: "bold"
			}), _.value.description ? (o(), r("span", h, c(_.value.description), 1)) : (o(), r("span", g, c(_.value.url), 1))]),
			_: 1
		}, 8, [
			"aria-label",
			"href",
			"rel",
			"target"
		]))])) : n("", !0);
	}
});
//#endregion
export { _ as default };

//# sourceMappingURL=ExternalDocs.vue.script.js.map